import { render } from "./partnerTr.vue?vue&type=template&id=4175a686&scoped=true"
import script from "./partnerTr.vue?vue&type=script&lang=js"
export * from "./partnerTr.vue?vue&type=script&lang=js"

import "./partnerTr.vue?vue&type=style&index=0&id=4175a686&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4175a686"]])

export default __exports__